// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__eiBLu","productName":"Table_productName__2TBu4"};